<svg
  [attr.aria-hidden]="ariaHidden()"
  [attr.aria-label]="ariaLabel() || null">
    <use [attr.xlink:href]="useRef()"></use>
</svg>

